import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders} from  "@angular/common/http";
import { constVariables } from "../constants/ConstantPath";
import { BehaviorSubject } from 'rxjs';
@Injectable({
  providedIn: 'root'
})
export class CommonService {
	private cartCount = new BehaviorSubject({});
	private hoteldata = new BehaviorSubject({});
	private hotelsdata = new BehaviorSubject({});
	private loggedIn = new BehaviorSubject({});
	private updateSearchresults = new BehaviorSubject({});
	public cartItems = new BehaviorSubject({});
	private CartItemsTotal = new BehaviorSubject({});
	private CartHotelData = new BehaviorSubject({});
	private LoggedInCustData = new BehaviorSubject({});
	private calendarSearch = new BehaviorSubject({});
	public modifyReservation = new BehaviorSubject({});
	public showCart = new BehaviorSubject({});
	public showCommonLoader = new BehaviorSubject(false);
	public isLoggedIn = new BehaviorSubject(false);
	public searchData = new BehaviorSubject({});
	public blogSearch = new BehaviorSubject({});
	
	blogSearchParam = this.blogSearch.asObservable(); 
	totalCartCount = this.cartCount.asObservable();
	particularHotelData = this.hoteldata.asObservable();
	HotelsData = this.hotelsdata.asObservable();
	checkLoginStatus = this.loggedIn.asObservable();
	checkCartStatus = this.updateSearchresults.asObservable();
	checkcartItems = this.cartItems.asObservable();
	checkcartItemsTotal = this.CartItemsTotal.asObservable();
	checkcartHotelData = this.CartHotelData.asObservable();
	checkLoggedInCustData = this.LoggedInCustData.asObservable();
	calendarSearchStatus = this.calendarSearch.asObservable();
	modifyReservation1 = this.modifyReservation.asObservable();
	showcartpopup = this.showCart.asObservable();
	commonLoader = this.showCommonLoader.asObservable();
	userloggedIn = this.isLoggedIn.asObservable();
	SearchData = this.searchData.asObservable();
	// search reservation order
	reservationconf = new BehaviorSubject('');
  	orderinfo = this.reservationconf.asObservable();

  	// Reservation success page
  	reservationSuccess = new BehaviorSubject<any>(false);
  	reservationID = this.reservationSuccess.asObservable();

	constructor(private http: HttpClient) {
		
	}
  	updateCartData(cartCount) {
		this.cartCount.next({cartCount: cartCount});
	}

	updatecalendarSearchStatus(val) {
		this.calendarSearch.next(val);
	}
	updateHotelData(hoteldata){
		this.hoteldata.next(hoteldata);
	}
	updateHotelsData(hoteldata){
		this.hotelsdata.next(hoteldata);
	}
	updateshowCart(val){
		this.showCart.next(val);
	}

	updateCartItems(cartItems){
		this.cartItems.next(cartItems);
	}
	updateCartHotelData(CartHotelData){
		this.CartHotelData.next(CartHotelData);
	}
	updateCartItemsTotal(CartItemsTotal){
		this.CartItemsTotal.next(CartItemsTotal);
	}
	updateCartStatus(status){
		this.updateSearchresults.next(status);
	}
	updateLoggedInCustData(LoggedInCustData){
		this.updateSearchresults.next(LoggedInCustData);
	}
	updateSearchData(data){
		this.searchData.next(data);
	}
  	addSubscriber(data){
		let promise = new Promise((resolve, reject) => {
		    const url = constVariables.apiUrl +"frontend/Authorization/newletter_register";
		    this.http.post<any[]>(url,data).subscribe((res: any) => {
		    	resolve(res);
		    });
		});
		return promise;
	}
	
	getHotelSettings(data) {
		let promise = new Promise((resolve, reject) => {
		    const url = constVariables.apiUrl +"frontend/Home/get_hotel_settings";
		    this.http.post<any[]>(url,data).subscribe((res: any) => {
		    	resolve(res);
		    });
		});
		return promise;
	}

	getPriceModule(data){
		let promise = new Promise((resolve, reject) => {
		    const url = constVariables.apiUrl +"frontend/Searchresults/getPricesModuleData";
		    this.http.post<any[]>(url,data).subscribe((res: any) => {
		    	resolve(res);
		    });
		});
		return promise;
	}
	getMultiplePriceModule(data){
		let promise = new Promise((resolve, reject) => {
		    const url = constVariables.apiUrl +"frontend/Searchresults/getMultiplePriceModule";
		    this.http.post<any[]>(url,data).subscribe((res: any) => {
		    	resolve(res);
		    });
		});
		return promise;
	}
	getStopSellCtaCtd(data){
		let promise = new Promise((resolve, reject) => {
		    const url = constVariables.apiUrl +"frontend/Booking/stopsell_ctd_cta";
		    this.http.post<any[]>(url,data).subscribe((res: any) => {
		    	resolve(res);
		    });
		});
		return promise;
	}

	loadCartData(data){
		let promise = new Promise((resolve, reject) => {
		    const url = constVariables.apiUrl +"frontend/Cart/load_cart_data";
		    this.http.post<any[]>(url,data).subscribe((res: any) => {
		    	resolve(res);
		    });
		});
		return promise;
	}

	/*
	*	Update LoggedIn status Observable
	*/ 
	updateLoggedInStatus(val) {
		this.loggedIn.next(val);
	}

	deleteCartItem(data){
		let promise = new Promise((resolve, reject) => {
		    const url = constVariables.apiUrl +'frontend/cart/delete_cart_item';
		    this.http.post<any[]>(url,data).subscribe((res: any) => {
		    	resolve(res);
		    });
		});
		return promise;
	}
	deleteCart(data){
		let promise = new Promise((resolve, reject) => {
		    const url = constVariables.apiUrl +'frontend/cart/delete_cart';
		    this.http.post<any[]>(url,data).subscribe((res: any) => {
		    	resolve(res);
		    });
		});
		return promise;
	}
	updateCart(data){
		let promise = new Promise((resolve, reject) => {
		    const url = constVariables.apiUrl +'frontend/cart/update_cart_item';
		    this.http.post<any[]>(url,data).subscribe((res: any) => {
		    	resolve(res);
		    });
		});
		return promise;
	}
	getPOSProductsFe(data){
		let promise = new Promise((resolve, reject) => {
		    const url = constVariables.apiUrl +"frontend/Searchresults/get_pos_available_on_fe";
		    this.http.post<any[]>(url,data).subscribe((res: any) => {
		    	resolve(res);
		    });
		});
		return promise;
	}
	getGiftCard(data){
		let promise = new Promise((resolve, reject) => {
		    const url = constVariables.apiUrl +"frontend/Booking/get_gift_card";
		    this.http.post<any[]>(url,data).subscribe((res: any) => {
		    	resolve(res);
		    });
		});
		return promise;
	}

	mergeCartItem(data){
		let promise = new Promise((resolve, reject) => {
		    const url = constVariables.apiUrl +"frontend/cart/merge_customer_cart_avail";
		    this.http.post<any[]>(url,data).subscribe((res: any) => {
		    	resolve(res);
		    });
		});
		return promise;
	}

	getReservationConf(conf:string) {
		this.reservationconf.next(conf);
	}

	setReservationSuccessID(reservationID:any) {
		this.reservationSuccess.next(reservationID);
	}
	// cartGiftCardWithRooms(data){
	// 	let promise = new Promise((resolve, reject) => {
	// 	    const url = constVariables.apiUrl +"frontend/cart/cart_giftcard_with_rooms";
	// 	    this.http.post<any[]>(url,data).subscribe((res: any) => {
	// 	    	resolve(res);
	// 	    });
	// 	});
	// 	return promise;
	// }

	checkAvailForModify(data) {
		let promise = new Promise((resolve, reject) => {
		    const url = constVariables.apiUrl +"frontend/Reservations/checkAvailForModify";
		    this.http.post<any[]>(url,data).subscribe((res: any) => {
		    	resolve(res);
		    });
		});
		return promise;
	}

	updatePosCart(data){
		let promise = new Promise((resolve, reject) => {
		    const url = constVariables.apiUrl +'frontend/cart/update_pos_cart_item';
		    this.http.post<any[]>(url,data).subscribe((res: any) => {
		    	resolve(res);
		    });
		});
		return promise;
	}

	makeAutoCompleteAddress(result) {
  		let address = {
            country: '',
            state: '',
            city: '',
            street: '',
            sublocality2: '',
            sublocality: '',
            street_number: '',
            postal_code: ''
        };

        let addressValue = '';
        let formatedAddr = result.formatted_address;
        let name = result.name;
        if (formatedAddr.includes(name)) {
            addressValue = formatedAddr;
        } else {
            addressValue = name+' '+formatedAddr;
        }
        return addressValue;
  	}

  	getHotels(data) {
		let promise = new Promise((resolve, reject) => {
		    const url = constVariables.apiUrl +"frontend/Searchresults/searchHotelResults";
		    this.http.post<any[]>(url,data).subscribe((res: any) => {
		    	resolve(res);
		    });
		});
		return promise;
	}

}
